import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getVisitasPanel = async (searchSelId,searchCliId,dateFrom,dateUntil,hourFrom,hourUntil, tienePedido, page, perPage) => {
    let queryParams = [];
    if (searchSelId) {
        queryParams.push(`sel_id=${encodeURIComponent(searchSelId || '')}`);
    }
    if (searchCliId) {
        queryParams.push(`cli_id=${encodeURIComponent(searchCliId || '')}`);
    }
     if (dateFrom) {
      queryParams.push(`fechaDesde=${encodeURIComponent(dateFrom)}`);
    }
    if (dateUntil) {
      queryParams.push(`fechaHasta=${encodeURIComponent(dateUntil)}`);
    } 
    if (hourFrom) {
      queryParams.push(`horaDesde=${encodeURIComponent(hourFrom)}`);
    }
    if (hourUntil) {
      queryParams.push(`horaHasta=${encodeURIComponent(hourUntil)}`);
    }
    if (tienePedido) {
      queryParams.push(`tienepedido=${encodeURIComponent(tienePedido)}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/visitas/busquedaVisitas_filtros", queryString);
};

export const getRutasPanel = async (searchSelId,dateSelected,hourFrom,hourUntil) => {
    let queryParams = [];
    if (searchSelId) {
        queryParams.push(`sel_id=${encodeURIComponent(searchSelId || '')}`);
    } 
     if (dateSelected) {
      queryParams.push(`fechaConsulta=${encodeURIComponent(dateSelected)}`);
    } 
    if (hourFrom) {
      queryParams.push(`horaDesde=${encodeURIComponent(hourFrom)}`);
    }
    if (hourUntil) {
      queryParams.push(`horaHasta=${encodeURIComponent(hourUntil)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/visitas/busquedaRutas_filtros", queryString);
};

export const getVisitaById = async (id) => {
    const res = await getData(`/visitas/${id}`)
    return res
}

export const postVisita = async (body) => {
    const res = await postData('/visitas', body)
    return res
}

export const patchVisita = async (id, body) => {
    const res = await patchData(`/visitas/${id}`, body)
    return res
}

export const deleteVisita = async (id) => {
    const res = await deleteData(`/visitas/${id}`)
    return res
}